import React, { Component } from 'react';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import './../css/issueStock.css';
import './../css/master.css';
import Header from './header.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ReactImageMagnify from 'react-image-magnify';

var httpURL = '';
var queryString = require('querystring');
var lstIssueStock = [];
var lstStockLocation = [];
var lstTransaction = [];
var formHeader = "";
var mode = 0;
var ipoDesignId = 0;

var designId = 0;

class issueStock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flg: true,
            opacity: 1,
            stock: '',
            stockLocation: '',
            loader: 'none',
            startDate: new Date(),
            src: require('./../images/blank.png'),
            designImagePath: require('./../images/blank.png'),
        }
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(date) {
        this.setState({
            startDate: date
        });
    }

    async componentWillUnmount() {
        await localStorage.removeItem('stock');
    }

    async componentDidMount() {
        $('#stockLocationCmb').prepend($("<option> </option>").val(0).html('Stock Location'));
        $('#stockAddForm input , #stockLocationCmb, .saveButton').attr('disabled', true);
        $('.transactionTableWrapper').removeClass('showTable');

        var detail = await localStorage.getItem('stock');
        var details = JSON.parse(detail);
        if (details.flag == "returnStock") {
            $('#batchNo').attr('disabled', true)
            $('#designColorImageDivStock').css({ 'visibility': 'hidden' });
            formHeader = "Return Stock";
            mode = 'R';
        }
        else if (details.flag == "issueStock") {
            // $('#batchNo').attr('disabled', false);
            $('#designColorImageDivStock').css({ 'visibility': 'visible' });
            formHeader = "Issue Stock";
            mode = 'I';
        }
        designId = details.designId;
        $('#ipoId').val(details.ipoId);
        $('#ipoNo').val(details.ipoNo);
        $('#bpoId').val(details.bpoId);
        $('#bpoNo').val(details.bpoNo);
        $('#designId').val(details.designId);
        $('#designNoColor').val(details.designNoColor);

        ipoDesignId = details.ipoDesignId;



        this.setState({ loader: 'block', opacity: 0.5, designImagePath: details.imageUrl });
        await axiosInstance.get(httpURL + '/a/mst/sto/list', {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                this.setState({
                    stockLocation: response.data.lstStockLocation,
                })
                lstStockLocation = this.state.stockLocation;
                this.fillStockLocation();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

        this.getStockList(designId);

    }

    getStockList = (designId) => {
        axiosInstance.post(httpURL + '/a/ipo/liststockfordesign',
            queryString.stringify({ 'designId': designId }), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                this.setState({
                    stock: response.data.lstStock,
                })
                lstIssueStock = this.state.stock;
                this.setStockTable();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

    }

    getTransactionList = (ipoDesignId) => {
        axiosInstance.post(httpURL + '/a/ipo/listtransaction',
            queryString.stringify({ 'ipoDesignId': ipoDesignId }), {
            withCredentials: true
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                lstTransaction = response.data.lstTransaction;
                console.log(lstTransaction);
                this.setTransactionTable();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

    }

    fillStockLocation = () => {
        $('#stockLocationCmb').empty();
        $('#stockLocationCmb').prepend($("<option> </option>").val(0).html('Stock Location'));
        for (var i = 0; i < lstStockLocation.length; i++) {
            var stockLocationId = lstStockLocation[i].stockLocationId;
            var stockLocation = lstStockLocation[i].stockLocation;
            $('#stockLocationCmb').append($('<option></option>').val(stockLocationId).html(stockLocation));
        }
    }


    setStockTable = () => {
        $('#stockTableBody tr').remove();
        var table = document.getElementById('stockTable');
        var tbody = document.getElementById('stockTableBody');
        var filterStock = $('#stockLocationFilter').val().toLowerCase();

        for (var i = 0; i < lstIssueStock.length; i++) {

            var id = lstIssueStock[i].stockId;
            var stockLocationId = lstIssueStock[i].stockLocationId;
            var stockLocation = lstIssueStock[i].stockLocation;
            var designId = lstIssueStock[i].designId;
            var designNoColor = lstIssueStock[i].designNoColor;
            var batchNo = lstIssueStock[i].batchNo;
            var folioNo = lstIssueStock[i].folioNo;
            var stockDt = lstIssueStock[i].stockDt;
            var quantity = lstIssueStock[i].quantity;

            var row = document.createElement('tr');
            row.id = id;
            row.onclick = (e) => {
                $(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
                var stockLocationId = $('#stockTableBody tr.selected').find('td:eq(0)').text();
                $('.saveButton').attr('disabled', false);
                this.setStockForm(stockLocationId);
                this.setState({ flg: false });
                if (mode == 'R') {
                    $('#stockAddForm input , #stockLocationCmb').attr('disabled', false);
                }
            }

            if (stockLocation != null && stockLocation.toLowerCase().indexOf(filterStock) === -1)
                continue;


            this.addTD(row, id, 'no-display');
            this.addTD(row, stockLocationId, 'no-display');
            this.addTD(row, stockDt, 'text-center');
            this.addTD(row, stockLocation, '');
            this.addTD(row, folioNo, '');
            this.addTD(row, quantity, 'text-right');
            tbody.append(row);
        }
        table.append(tbody);
    }

    setTransactionTable = () => {
        $('#transactionTableBody tr').remove();
        var table = document.getElementById('transactionTable');
        var tbody = document.getElementById('transactionTableBody');
        var filterBatchNo = $('#batchNoFilter').val().toLowerCase();

        for (var i = 0; i < lstTransaction.length; i++) {

            var id = lstTransaction[i].stockId;
            var stockLocationId = lstTransaction[i].stockLocationId;
            var stockLocation = lstTransaction[i].stockLocation;
            var batchNo = lstTransaction[i].batchNo;
            var folioNo = lstTransaction[i].folioNo;
            var quantity = lstTransaction[i].quantity;
            var mode = lstTransaction[i].mode;
            var transactionDt = lstTransaction[i].transactionDt;

            var row = document.createElement('tr');


            if (batchNo != null && batchNo.toLowerCase().indexOf(filterBatchNo) === -1)
                continue;

            this.addTD(row, id, 'no-display');
            this.addTD(row, stockLocationId, 'no-display');
            this.addTD(row, transactionDt, 'text-center');
            this.addTD(row, stockLocation, 'text-center');
            this.addTD(row, batchNo, 'text-center');
            this.addTD(row, folioNo, 'text-center');
            this.addTD(row, quantity, 'text-right');
            this.addTD(row, mode, 'text-center');
            tbody.append(row);
        }
        table.append(tbody);
    }

    addTD(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        var text = document.createTextNode(val);
        cell.append(text);
        row.append(cell);
    }

    setStockForm = (id) => {
        $('#stockAddForm input , #stockLocationCmb').attr('disabled', true);
        $('#stockAddForm #quantity').attr('disabled', false);
        var stockData = this.getStockData(id);
        if (stockData !== -1) {
            $('#stockLocationCmb').val(stockData.stockLocationId);
            $('#input_designColor').val(stockData.designNoColor);
            $('#batchNo').val(stockData.batchNo);
            $('#folioNo').val(stockData.folioNo);
            if (mode == 'R') {
                $('#quantity').val("");
            }
            else {
                $('#quantity').val(stockData.quantity);
            }



            var date = stockData.stockDt;
            date = date.split('-');

            var setDate = date.reverse().join();
            setDate = setDate.replace(/,/g, '-');
            var startDate = new Date(setDate);
            this.setState({
                startDate: startDate,
            });

        }
    }

    getStockData(id) {
        for (var i = 0; i < lstIssueStock.length; i++) {
            if (id == lstIssueStock[i].stockId) {
                return lstIssueStock[i];
            }
        }
        return -1;
    }

    addStockReady = () => {
        $('#stockAddForm').trigger('reset');
        $('#stockTableBody tr.selected').removeClass('selected');
        $('.saveButton').attr('disabled', true);

        this.setState({
            flg: true,
            startDate: null,
        });
    }

    maintainStock = () => {
        if (this.state.flg) {
            this.addStock();
        } else {
            this.editStock();
        }
    }


    // addStock = () => {
    //     var stockArr = {};
    //     var stockId = 0;
    //     var stockLocationId = $('#stockLocationCmb').find('option:selected').val();
    //     var stockLocation = $('#stockLocationCmb').find('option:selected').text();

    //     var batchNo = $('#batchNo').val();
    //     var folioNo = $('#folioNo').val();
    //     var quantity = $('#quantity').val();
    //     var stockDate = $('#stockDate').val();

    //     if (stockLocationId == 0) {
    //         toast.warning('Please Select Valid stock location');
    //         document.getElementById('stockLocationCmb').focus();
    //         return false;
    //     }

    //     if (batchNo == '') {
    //         toast.warning('Please Fill Batch Number');
    //         $('#batchNo').focus();
    //         return false;
    //     }
    //     if (folioNo == '') {
    //         toast.warning('Please Fill Folio Number');
    //         $('#folioNo').focus();
    //         return false;
    //     }
    //     if (quantity == '') {
    //         toast.warning('Please Fill Quantity');
    //         $('#quantity').focus();
    //         return false;
    //     }
    //     if (stockDate == '') {
    //         toast.warning('Please Fill Date');
    //         $('#stockDate').focus();
    //         return false;
    //     }


    //     stockArr = {
    //         'stockId': stockId, 'stockLocationId': stockLocationId, 'ipoDesignId': ipoDesignId,
    //         'batchNo': batchNo, 'folioNo': folioNo, 'quantity': quantity, 'mode': mode
    //     }
    //     this.setState({ loader: 'block', opacity: 0.5 });
    //     axiosInstance.post(httpURL + '/a/ipo/savestock',
    //         queryString.stringify({ 'stock': JSON.stringify(stockArr) }), { withCredentials: true }
    //     ).then((response) => {
    //         if (response.data.SvcStatus === "Success") {
    //             toast.success(response.data.SvcMsg);
    //             stockArr.stockId = response.data.stockId;
    //             stockArr.stockLocation = stockLocation;
    //             lstIssueStock.push(stockArr);
    //             this.setStockTable();
    //             this.setStockForm(response.data.stockId);
    //             this.highlightRow('stockTableBody', response.data.stockId);
    //             this.setState({ flg: false })
    //         }
    //         else {
    //             toast.error(response.data.SvcMsg);
    //         }
    //         this.setState({ loader: 'none', opacity: 1 });
    //     }).catch((e) => {
    //         toast.error("Service failed " + e);
    //     });
    // }

    editStock = () => {
        var stockArr = {};
        var stockId = $('#stockTableBody tr.selected').find('td:eq(0)').text();
        var stockLocationId = $('#stockLocationCmb').find('option:selected').val();
        var stockLocation = $('#stockLocationCmb').find('option:selected').text();
        var batchNo = $('#batchNo').val();
        var folioNo = $('#folioNo').val();
        var quantity = $('#quantity').val();
        var stockDate = $('#stockDate').val();

        if (stockLocationId == 0) {
            toast.warning('Please Select Valid stock location');
            document.getElementById('stockLocationCmb').focus();
            return false;
        }

        if (batchNo == '') {
            toast.warning('Please Fill Batch Number');
            $('#batchNo').focus();
            return false;
        }
        if (folioNo == '') {
            toast.warning('Please Fill Folio Number');
            $('#folioNo').focus();
            return false;
        }
        if (quantity == '') {
            toast.warning('Please Fill Quantity');
            $('#quantity').focus();
            return false;
        }
        if (stockDate == '') {
            toast.warning('Please Fill Date');
            $('#stockDate').focus();
            return false;
        }

        if (mode == "I") {
            stockArr = {
                'stockId': stockId, 'ipoDesignId': ipoDesignId,
                'batchNo': batchNo, 'folioNo': folioNo, 'quantity': quantity, 'mode': mode
            }
            var tableQuantity = $('#stockTableBody tr.selected').find('td:eq(5)').text();
            // if(tableQuantity < quantity)
            // {
            //     toast.warning('Quantity should be less than stock quantity');
            //     $('#quantity').focus();
            //     return false;
            // }
            this.setState({ loader: 'block', opacity: 0.5 });
            axiosInstance.post(httpURL + '/a/ipo/savestock',
                queryString.stringify({ 'stock': JSON.stringify(stockArr) }), { withCredentials: true }
            ).then((response) => {
                if (response.data.SvcStatus === "Success") {
                    toast.success(response.data.SvcMsg);
                    this.getStockList(designId);
                    this.setStockTable();
                    this.addStockReady();
                }
                else {
                    toast.error(response.data.SvcMsg);
                }
                this.setState({ loader: 'none', opacity: 1 });
            }).catch((e) => {
                toast.error("Service failed " + e);
            });
        }
        else if (mode == "R") {
            stockArr = {
                'stockId': stockId, 'stockLocationId': stockLocationId, 'ipoDesignId': ipoDesignId, 'designId': designId,
                'batchNo': batchNo, 'folioNo': folioNo, 'quantity': quantity, 'stockDt': stockDate
            }
            this.setState({ loader: 'block', opacity: 0.5 });
            axiosInstance.post(httpURL + '/a/bpo/stock/return',
                queryString.stringify({ 'return': JSON.stringify(stockArr) }), { withCredentials: true }
            ).then((response) => {
                if (response.data.SvcStatus === "Success") {
                    toast.success(response.data.SvcMsg);
                    this.getStockList(designId);
                    this.setStockTable();
                    this.addStockReady();
                }
                else {
                    toast.error(response.data.SvcMsg);
                }
                this.setState({ loader: 'none', opacity: 1 });
            }).catch((e) => {
                toast.error("Service failed " + e);
            });
        }
    }

    getIdxStock(stockId) {
        for (var i = 0; i < lstIssueStock.length; i++) {
            if (lstIssueStock[i].stockId == stockId) {
                return i;
            }
        }
        return -1;
    }

    highlightRow(table, id) {
        $('#' + table + ' tr').each(function () {
            var stockId = $(this).find('td:eq(0)').text();
            if (stockId == id) {
                $(this).addClass('selected').siblings().removeClass('selected');
            }
        });
    }
    showTable = (e) => {
        this.getTransactionList(ipoDesignId);
        $('body').addClass('showTable');
    }
    hideTable = () => {
        $('body').removeClass('showTable');
    }




    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <Header />
                <ToastContainer autoClose={2000} hideProgressBar />
                <div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
                    <img src={require("../images/loader.gif")} alt="Loader..." />
                </div>
                <div className="main issueStock" style={{ opacity: this.state.opacity }}>
                    <div className="container-fluid">
                        <div className="col-md-11 col-centered clearfix">
                            <div className="col-md-10 styleBackground" style={{ padding: 15 }}>
                                <form className="form-inline">
                                    <div className="form-group">
                                        <label style={{ width: 100 }} htmlFor="ipoNo">IPO NO:</label>
                                        <input style={{ display: 'none' }} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
                                        <input style={{ display: 'none' }} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
                                        <input style={{ marginLeft: 2 }} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
                                    </div>
                                    <div className="form-group">
                                        <label style={{ marginLeft: 10, width: 100 }} htmlFor="bpoNo">BPO NO:</label>
                                        <input style={{ display: 'none' }} placeholder="BPO Id" type="text" className="form-control" id="bpoId" />
                                        <input style={{ marginLeft: 2 }} readOnly placeholder="BPO Number" type="text" className="form-control" id="bpoNo" />
                                    </div>
                                    <div className="form-group">
                                        <label style={{ marginLeft: 10, width: 100 }} htmlFor="designNoColor">Design Color:</label>
                                        <input style={{ display: 'none' }} placeholder="Design Id" type="text" className="form-control" id="designId" />
                                        <input style={{ marginLeft: 2 }} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
                                    </div>
                                </form>
                            </div>
                            <div className="col-sm-2">
                                <div className="pull-right" id="designColorImageDivStock">
                                    <ReactImageMagnify {...{
                                        smallImage: {
                                            alt: 'Design Image',
                                            src: this.state.designImagePath,
                                            isFluidWidth: true,
                                        },
                                        largeImage: {
                                            src: this.state.designImagePath,
                                            width: 600,
                                            height: 900
                                        },
                                        enlargedImageContainerDimensions: {
                                            width: 200,
                                            height: 200,
                                        },
                                        enlargedImageContainerStyle: {
                                            left: -220,
                                            top: 0,
                                            zIndex: 1000,
                                        },
                                    }} />
                                </div>
                            </div>
                            <div className="viewWrapper">
                                <button className="btn btn-info transactionButton" onClick={this.showTable}>View Transaction</button>
                            </div>
                            <div className="col-sm-7 transactionTableWrapper" >
                                <h5 className="formHeader">Stock Transaction</h5>
                                <table className="tableLayout tableWidth">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 50, display: 'none' }}>Stock Id</th>
                                            <th style={{ width: 40 }}> Date</th>
                                            <th style={{ width: 40 }}> Stock Location</th>
                                            <th style={{ width: 40 }}>
                                                <input onChange={this.setTransactionTable} type="text" className="form-control inp-search" id="batchNoFilter" placeholder="Batch Number" />
                                            </th>
                                            <th style={{ width: 40 }}> Folio No.</th>
                                            <th style={{ width: 40 }}> Quantity</th>
                                            <th style={{ width: 40 }}> Mode</th>

                                        </tr>
                                    </thead>
                                </table>
                                <div className="transactionTableDiv col-sm-12 col-xs-11 padding-remove">
                                    <table id="transactionTable" className="tableLayout">
                                        <colgroup>
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="40" />
                                            <col width="40" />
                                        </colgroup>
                                        <tbody id="transactionTableBody"></tbody>
                                    </table>
                                </div>
                                <button className="btn btn-danger closeButton" onClick={this.hideTable}><span className="glyphicon glyphicon-remove"></span></button>
                            </div>
                        </div>
                        <div className="col-sm-11 col-centered clearfix bottomStockWrapper">
                            <div className="col-sm-7 col-xs-11 padding-remove">
                                <table className="tableLayout tableWidth">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 50, display: 'none' }}>Stock Id</th>
                                            <th style={{ width: 40 }}> Date</th>
                                            <th style={{ width: 50 }}>
                                                <input onChange={this.setStockTable} type="text" className="form-control inp-search" id="stockLocationFilter" placeholder="Stock Location" />
                                            </th>
                                            <th style={{ width: 40 }}> Folio No.</th>
                                            <th style={{ width: 40 }}> Quantity</th>

                                        </tr>
                                    </thead>
                                </table>
                                <div className="stockTableDiv col-sm-12 col-xs-11 padding-remove">
                                    <table id="stockTable" className="tableLayout">
                                        <colgroup>
                                            <col width="40" />
                                            <col width="50" />
                                            <col width="40" />
                                            <col width="40" />
                                        </colgroup>
                                        <tbody id="stockTableBody"></tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-sm-1 col-xs-1 stockReadyPlusButton">
                                <span id="addStock" title="Add stock" onClick={this.addStockReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <form id="stockAddForm" className="form-horizontal">
                                    <h5 className="formHeader">{formHeader}</h5>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Stock Location:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <select type="text" className="form-control" placeholder="Stock" id="stockLocationCmb" />

                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Batch No:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control" placeholder="Batch Number" id="batchNo" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Folio No.:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control" placeholder="Folio Number" id="folioNo" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Quantity:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <input type="text" className="form-control text-right" placeholder="Quantity" id="quantity" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="control-label col-sm-5">Date:<span style={{ color: 'red' }}>*</span></label>
                                        <div className="col-sm-7">
                                            <DatePicker id="stockDate"
                                                className='form-control text-center'
                                                placeholderText="Date"
                                                selected={this.state.startDate}
                                                onChange={this.handleChange}
                                                dateFormat="dd-MM-yyyy"
                                                autoComplete='off'
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group" style={{ marginTop: 20 }}>
                                        <div className="col-sm-12 text-center">
                                            <button type="button" onClick={this.maintainStock} className="btn btn-warning saveButton">Save</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default issueStock;